// @flow

// Types
import type {
  Asset,
  AssetsById,
} from 'fc-model-assets/types'

import {
  PROP_CATEGORY,
  FARM,
} from 'fc-model-assets'

// Libs
import { createSelector } from 'reselect'
import _filter from 'lodash/filter'

// Selectors
import { assets$ } from 'fc-assets'


export default createSelector(
  [assets$],
  function (assets: AssetsById): Array<Asset> {
    return _filter(assets, (asset: Asset): boolean => {
      if (asset[PROP_CATEGORY]) {
        return asset[PROP_CATEGORY] === FARM
      }
    })
  }
)
